import React from "react";
import "./navigation.scss";


class Navigation extends React.Component {

    render() {
        return (
            <nav className="navbar navbar-expand-sm fixed-top static-top">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <img src={require("./logo.png")} alt="Logo SIB GmbH"/>
                    </a>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <a className="nav-link" href="#ueber_mich">Über mich</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#projekte">Aktuelle Projekte</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#kontakt">Kontakt</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }

}

export default Navigation;



// WEBPACK FOOTER //
// ./src/navigation/navigation.js